// Função utilitária para formatar data sem conversão de timezone
export const formatarDataSemTimezone = (dataStr: string | null | undefined): string => {
  if (!dataStr) return '-';
  
  try {
    // Converter para string se vier como objeto
    const dataString = String(dataStr);
    
    // Regex para capturar data e hora em diversos formatos
    // Formato ISO: 2026-01-13T13:50:27.000Z ou 2026-01-13T13:50:27
    // Formato SQL: 2026-01-13 13:50:27
    const dateMatch = dataString.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/);
    
    if (dateMatch) {
      const [_, ano, mes, dia, hora, minuto, segundo] = dateMatch;
      return `${dia}/${mes}/${ano}, ${hora}:${minuto}:${segundo}`;
    }
    
    // Formato alternativo dd/MM/yyyy HH:mm:ss
    const dateMatch2 = dataString.match(/(\d{2})\/(\d{2})\/(\d{4})[, ]+(\d{2}):(\d{2}):(\d{2})/);
    if (dateMatch2) {
      const [_, dia, mes, ano, hora, minuto, segundo] = dateMatch2;
      return `${dia}/${mes}/${ano}, ${hora}:${minuto}:${segundo}`;
    }
    
    return '-';
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return '-';
  }
};

export const formatarHoraSemTimezone = (dataStr: string | null | undefined): string => {
  if (!dataStr) return '-';
  
  try {
    // Converter para string se vier como objeto
    const dataString = String(dataStr);
    
    // Extrair apenas a hora
    const dateMatch = dataString.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/);
    
    if (dateMatch) {
      const [_, ano, mes, dia, hora, minuto, segundo] = dateMatch;
      return `${hora}:${minuto}:${segundo}`;
    }
    
    // Formato alternativo
    const timeMatch = dataString.match(/(\d{2}):(\d{2}):(\d{2})/);
    if (timeMatch) {
      const [_, hora, minuto, segundo] = timeMatch;
      return `${hora}:${minuto}:${segundo}`;
    }
    
    return '-';
  } catch (error) {
    console.error('Erro ao formatar hora:', error);
    return '-';
  }
};
